/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PaymentMethodDestroyPathParams, PaymentMethodDestroyResponse } from '../types/PaymentMethodDestroy'

/**
 * DELETE /:organisation/payment-methods/:paymentMethod
 * @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::destroy
 */
export async function paymentMethodDestroy(
	organisation: PaymentMethodDestroyPathParams['organisation'],
	paymentMethod: PaymentMethodDestroyPathParams['paymentMethod'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PaymentMethodDestroyResponse>> {
	return axiosInstance.delete(`/${organisation}/payment-methods/${paymentMethod}`, config)
}
